import * as React from 'react';
import { Show, ShowProps, SimpleShowLayout } from 'react-admin';
import UsageChart from '../shared/UsageChart';

interface IUserShowProps extends ShowProps {}

const UserShow: React.FunctionComponent<IUserShowProps> = (props) => (
    <Show {...props}>
        <SimpleShowLayout>
            <UsageChart />
        </SimpleShowLayout>
    </Show>
);

export default React.memo(UserShow);
